import { useEffect, useState } from 'react';

const multiselectKeys = [
  'MetaLeft',
  'MetaRight',
  'ControlLeft',
  'ControlRight',
];

export const useGallerySelection = ({
  clearSelection,
  filesGalleryRef,
  foldersGalleryRef,
}: {
  clearSelection: () => void;
  filesGalleryRef: React.MutableRefObject<HTMLDivElement | null>;
  foldersGalleryRef: React.MutableRefObject<HTMLDivElement | null>;
}) => {
  const [multiselect, setMultiselect] = useState(false);

  useEffect(() => {
    const addMultiselect = function (ev: KeyboardEvent) {
      if (multiselectKeys.includes(ev.code)) {
        setMultiselect(true);
      }
    };

    const removeMultiselect = function (ev: KeyboardEvent) {
      if (multiselectKeys.includes(ev.code)) {
        setMultiselect(false);
      }
    };

    const removeSelection = function (ev: MouseEvent) {
      const target = ev.target as any;
      if (
        (target && target.id === 'bulkMove') ||
        target.id === 'bulkDelete' ||
        target.id === 'backToTop'
      ) {
        return;
      }
      if (
        foldersGalleryRef?.current &&
        !foldersGalleryRef.current.contains(target) &&
        filesGalleryRef?.current &&
        !filesGalleryRef.current.contains(target)
      ) {
        clearSelection();
      }
    };

    const application = document.getElementById('application');
    document.addEventListener('keydown', addMultiselect);
    application && application.addEventListener('keyup', removeMultiselect);
    application && application.addEventListener('click', removeSelection);

    return () => {
      document.removeEventListener('keydown', addMultiselect);
      application &&
        application.removeEventListener('keyup', removeMultiselect);
      application && application.removeEventListener('click', removeSelection);
    };
  }, []);

  return {
    multiselect,
  };
};
